import { render, staticRenderFns } from "./use-cases.vue?vue&type=template&id=f8cca860&scoped=true&"
import script from "./use-cases.vue?vue&type=script&lang=js&"
export * from "./use-cases.vue?vue&type=script&lang=js&"
import style0 from "./use-cases.vue?vue&type=style&index=0&id=f8cca860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cca860",
  null
  
)

export default component.exports